import React from "react";
import { useNavigate } from "react-router-dom";
import carewindow from "images/carewindow.png";

function Sidebar({ org, setActiveComponent, isAdmin, isSuperAdmin, isManager }) {
    const navigate = useNavigate();
    
    return (
        <nav id="sidebar" style={{ zIndex: 1049 }}>
            <div className="sidebar_blog_1">
                <div className="sidebar-header">
                    <div className="logo_section" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "0", }} >
                        <img className="img-responsive" src={carewindow} alt="carewindow" style={{ height: "52px" }} />
                    </div>
                </div>
                <div className="sidebar_user_info">
                    <div className="user_profle_side">
                        <div className="user_info"></div>
                    </div>
                </div>
            </div>
            <div className="sidebar_blog_2">
                {org?.code === "konnekt" ?
                    <ul className="list-unstyled components" style={{ marginTop: "30px" }}>
                        <li onClick={() => setActiveComponent("Register Konnekt")}>
                            <a href="#registerKonnekt">
                                <i className="fa fa-plus-square-o orange_color"></i>{" "}
                                <span>Register a Konnekt</span>
                            </a>
                        </li>
                        <li onClick={() => setActiveComponent("Manage Devices")}>
                            <a href="#managedevices">
                                <i className="fa fa-laptop purple_color"></i>{" "}
                                <span>Manage Devices</span>
                            </a>
                        </li>
                        <li onClick={() => setActiveComponent("Manage Users")}>
                            <a href="#manageusers">
                                <i className="fa fa-users yellow_color"></i>{" "}
                                <span>Manage Users</span>
                            </a>
                        </li>
                        {isAdmin || isSuperAdmin ? (
                            <li style={{ marginTop: "50px" }} onClick={() => navigate("/organise")} >
                                <a href="#">
                                    <i className="fa fa-sign-out red_color"></i>{" "}
                                    <span>Back to Admin Page</span>
                                </a>
                            </li>
                        ) : null}
                    </ul>
                    :
                    <ul className="list-unstyled components" style={{ marginTop: "30px" }}>
                        <li onClick={() => setActiveComponent("Add Devices")} id="menu_adddevice">
                            <a href="#adddevices">
                                <i className="fa fa-plus-square-o orange_color"></i>{" "}
                                <span>Add Devices</span>
                            </a>
                        </li>
                        <li onClick={() => setActiveComponent("Manage Devices")} id="menu_managedevice">
                            <a href="#managedevices">
                                <i className="fa fa-laptop purple_color"></i>{" "}
                                <span>Manage Devices</span>
                            </a>
                        </li>
                        {org?.orgType !== "family" &&
                            <li onClick={() => setActiveComponent("Policy Groups")}>
                                <a href="#managegroups">
                                    <i className="fa fa-file-o white_color"></i>{" "}
                                    <span>Device Groups</span>
                                </a>
                            </li>
                        }
                        <li onClick={() => setActiveComponent("Announcements")} id="menu_announcements">
                            <a href="#announcements">
                                <i className="fa fa-bell-o blue2_color"></i>{" "}
                                <span>{org?.orgType !== "family" ? "Announcements" : "Text Announcements"} </span>
                            </a>
                        </li>
                        {
                            org?.orgType !== "family" &&
                            <>
                                <li onClick={() => setActiveComponent("Forms")}>
                                    <a href="#forms">
                                        <i className="fa fa-wpforms blue1_color"></i>{" "}
                                        <span>Forms</span>
                                    </a>
                                </li>
                            </>
                        }
                        <li onClick={() => setActiveComponent('Event Calendar')}>
                            <a href="#calendar"><i className="fa fa-calendar purple_color2"></i> <span>Event Calendar</span></a>
                        </li>
                        <li onClick={() => setActiveComponent("Address Books")} id="menu_addressbooks">
                            <a href="#addressbooks">
                                <i className="fa fa-book green_color"></i>{" "}
                                <span>Address Books</span>
                            </a>
                        </li>
                        {/* <li onClick={() => setActiveComponent("Store")}>
                            <a href="#store">
                                 <i className="fa fa-shopping-cart"></i>{" "}
                                <span>Add-on Store</span>
                            </a>
                      </li> */}
                        {(isManager || isAdmin || isSuperAdmin) &&
                            <li onClick={() => setActiveComponent("Manage Users")} id="menu_manageusers">
                                <a href="#manageusers">
                                    <i className="fa fa-users yellow_color"></i>{" "}
                                    <span>Manage Users</span>
                                </a>
                            </li>
                        }
                        {isAdmin || isSuperAdmin ? (
                            <li style={{ marginTop: "50px" }} onClick={() => navigate("/organise")} >
                                <a href="#">
                                    <i className="fa fa-sign-out red_color"></i>{" "}
                                    <span>Back to Admin Page</span>
                                </a>
                            </li>
                        ) : null}
                    </ul>
                }
            </div>
        </nav>
    );
}


export default Sidebar;